import type { RxJsonSchema } from 'rxdb';
import type { RepairFactor } from './repairFactor.types';

export const repairFactorSchema: RxJsonSchema<RepairFactor> = {
  type: 'object',
  version: 0,
  description: 'describes repair Factor',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    discipline: { type: ['number', 'null'] },
    sort: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};
